import React, { useEffect, useState } from "react";
import {
  getFirestore,
  collection,
  query,
  getDocs,
} from "firebase/firestore";
import aos from "aos";
import NewsRow from "./NewsRow";
import EventRow from "./EventRow";

function NewsEvents() {
  const [newsdata, setnewsdata] = useState([]);
  const [eventsdata, seteventsdata] = useState([]);
  useEffect(() => {
    aos.init();
    async function getData() {
      const db = getFirestore();
      const q = query(collection(db, "News"));
      const querySnapshot = await getDocs(q);
      setnewsdata(querySnapshot.docs);
      const q2 = query(collection(db, "Events"));
      const querySnapshot2 = await getDocs(q2);
      seteventsdata(querySnapshot2.docs);
    }
    getData();
  }, []);
  return (
    <React.Fragment>
      <div className="container info">
        <div className="events" data-aos="fade-right">
          <table className="table table-hover">
            <thead>
              <th>News</th>
              <th> </th>
            </thead>
            <tbody id="news">
              {Object.values(newsdata).map((doc) => {
                return (
                  <NewsRow
                    id={doc.data().NewsId}
                    name={doc.data().NewsName}
                    date={doc.data().NewsDate}
                    description={doc.data().description}
                  ></NewsRow>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="news" data-aos="fade-left">
          <table className="table table-responsive table-hover">
            <thead>
              <th>Events</th>
              <th> </th>
            </thead>
            <tbody id="events">
              {Object.values(eventsdata).map((doc) => {
                return (
                  <EventRow
                    id={doc.data().EventId}
                    name={doc.data().EventName}
                    date={doc.data().EventDate}
                  ></EventRow>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  );
}
export default NewsEvents;
